import React from 'react'
import styles from './HomePage.module.css'
import HeroBannerSection from '../../sections/HeroBannerSection/HeroBannerSection'
import HeroSection from '../../sections/HeroSection/HeroSection'
import AboutSection from '../../sections/AboutSection/AboutSection'
import HomeServicesSection from '../../sections/HomeServicesSection/HomeServicesSection'
import ClientSection from '../../sections/ClientSection/ClientSection'
import HeroProjectSection from '../../sections/HeroProjectSection/HeroProjectSection'
import HomeFAQSection from '../../sections/HomeFAQSection/HomeFAQSection'
import TestimonialsSection from '../../sections/TestimonialsSection/TestimonialsSection'
const HomePage = () => {
    return (
        <>
            <HeroBannerSection />
            <HeroSection />
            <AboutSection />
            <HomeServicesSection />
            <ClientSection />
            <HeroProjectSection />
            <HomeFAQSection />
            {/* <TestimonialsSection /> */}
        </>
    )
}

export default HomePage